<template>
  <div class="p-8" :style='"padding-bottom: 0;color:"+data.style.color'>
    <div class="bor-rad-10 s_over_h p-8"
      :style="'background: linear-gradient(90deg, '+data.style.bgColor.left+' 0%, '+data.style.bgColor.right+' 100%);'">
      <p class="fz-15 s_font_b">{{data.style.taskTitle}}</p>
      <div class="">
        <div class="s_flex_bian_c p-t-10 p-b-10" v-for="(item,index) in list" :key="index">
          <img class="width-50 height-50 bor-rad-3" style="object-fit:cover;width:50px"
            :src="item.image?info.picdomain+item.image:require('@/assets/images/normal.png')" alt="">
          <div class="width55">
            <p class="fz-15 m-b-5 s_omit">{{item.name || '任务名称'}}</p>
            <p class="fz-12 s_omit">{{item.describe || '任务描述'}}</p>
          </div>
          <p class="height-25 width-60 fz-12 bor-rad-15 s_flex_center"
            style="background: linear-gradient(90deg, #D6A465 0%, #F6D7AA 100%);color:#916022">去完成</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { ref } from "vue";
  import store from "@/store";
  import { getIntegralList } from '@/api/assets'
  export default {
    props: { data: Object },
    name: "task",
    setup(props) {
      const list = ref([]);
      // 获取列表
      const initData = async () => {
        let res = await getIntegralList().then((res) => res.data);
        list.value = res.data;
      };
      initData();
      return {
        list,
        info: ref(store.state.user.info)
      }
    }
  };
</script>
<style>

</style>